export enum ActionTypes {
  ContactSales = 'contactSales',
  ContactSalesRequest = 'contactSales.request',
  ContactSalesSuccess = 'contactSales.success',
  ContactSalesFailure = 'contactSales.failure',

  ClearContactSalesServerErrors = 'clearContactSalesServerErrors',
}
